import React from "react";
import classnames from "classnames";
import { Option, ORDER_TYPE } from "@shared/interfaces";
import { Dropdown } from "@shared/components/Dropdown";

import { TableProperty, TableSort } from "../../interfaces";
import { SortableHeader } from "../SortableHeader";

import "./index.scss";

export interface HeadProps<T> extends TableSort {
  properties: TableProperty<T>[];
  total?: number;
  exportTable?: (value: string) => void;
  exportOptions?: Option[];
  isBorderRadius?: boolean;
}

function Head<T>(props: HeadProps<T>) {
  const { properties, sortBy, onChangeSorting, sortOrder, exportTable, exportOptions, isBorderRadius = true } = props;

  return (
    <div className={classnames("table-header", { "is-border-radius": isBorderRadius })}>
      <>
        <div className="export">
          {exportTable && exportOptions ? (
            <Dropdown title="Export" options={exportOptions} handleClick={exportTable} />
          ) : null}
        </div>
        {properties.map((prop) =>
          !prop.appearClickBlock ? (
            <div key={prop.title} className={classnames("table-header-cell", prop.headerClassName)}>
              {prop.sort ? (
                <SortableHeader
                  column={prop}
                  sortOrder={
                    sortBy && sortBy.find((sf) => prop.sort?.includes(sf)) && sortOrder ? sortOrder : ORDER_TYPE.NONE
                  }
                  onChangeSorting={onChangeSorting}
                />
              ) : (
                <div>{prop.title}</div>
              )}
            </div>
          ) : null,
        )}
      </>
    </div>
  );
}

export default Head;
